var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'produce-source': true, single: _vm.single }},[_vm._v(" "+_vm._s(_vm.produceSource)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }